import { QueryClient } from "@tanstack/react-query";

// The talent SPA's single TanStack Query client — same config as web's
// (frontend/web/src/lib/query-client.ts). Pusher is the source of truth for
// freshness: the worker pushes `seller.message` / `seller.thread.update` over the
// talent's private channel, so queries don't poll or refetch on focus. The
// Pusher→cache dispatcher (seller-stream-dispatcher.ts) patches the cache on a
// message and invalidates the affected detail on a thread.update. See
// frontend/seller/ARCHITECTURE.md for the data-flow contract.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: 1000 * 60 * 30,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
